<template>
	<define-template>
		<v-category-filter-range
			v-if="
				facet.type === 'RANGE' ||
				(facet.type === 'TEXT' && facet.id.includes('width')) ||
				(facet.type === 'TEXT' && facet.id.includes('height')) ||
				(facet.type === 'TEXT' &&
					facet.id.includes('custom.delivery_estimate_days'))
			"
			v-model="selectedFacets"
			:facet="facet"
		/>

		<client-only
			v-else-if="
				facet.type === 'TEXT' && facet.id === 'custom.facet_categories'
			"
		>
			<suspense>
				<v-category-filter-category-tree
					v-model="selectedFacets"
					:facet="facet"
				/>

				<template #fallback>
					<div class="flex items-center justify-center space-y-4">
						<span class="text-xl text-black">
							<v-icon class="animate-spin" icon="spinner"></v-icon>
						</span>
					</div>
				</template>
			</suspense>
		</client-only>

		<h-switch-group
			v-else-if="facet.type === 'TEXT' || facet.type === 'COLOR'"
			class="space-y-xs"
			as="div"
		>
			<v-category-filter-checkbox
				v-for="item in facet.values"
				:key="item.id"
				v-model="selectedFacets"
				:item="item"
			/>
		</h-switch-group>
	</define-template>

	<!-- Checkboxes are always shown non-disclosure-style -->
	<v-category-filter-toggle
		v-if="
			facet.type === 'CHECKBOX' ||
			(facet.type === 'TEXT' &&
				facet.id.includes('variant.custom.isAvailableQuickly')) ||
			(facet.type === 'TEXT' && facet.id.includes('custom.isNewProduct')) ||
			(facet.type === 'TEXT' && facet.id.includes('custom.isInCampaign'))
		"
		v-bind="$attrs"
		v-model="selectedFacets"
		:facet="facet"
	/>

	<!-- Render a simple facet element if non-disclosure is requested -->
	<div v-else-if="alwaysShow" v-bind="$attrs">
		<p class="mb-xs">{{ facet.label }}</p>

		<reuse-template />
	</div>

	<!-- Usually facets are wanted to be shown disclosure-style -->
	<v-disclosure v-else v-bind="$attrs" :is-open="isOpen" has-border>
		<template #button>
			<p>{{ facet.label }}</p>
		</template>

		<template #content>
			<reuse-template />
		</template>
	</v-disclosure>
</template>

<script lang="ts" setup>
import type {Facet} from "@apptus/esales-api";
import {useVModel, createReusableTemplate} from "@vueuse/core";

const properties = defineProps<{
	facet: Facet;
	modelValue?: (string | number | boolean)[];
	alwaysShow?: boolean;
}>();

const emit = defineEmits<{
	(event: "update:modelValue", value?: (string | number)[]): void;
}>();

const [defineTemplate, reuseTemplate] = createReusableTemplate();

const selectedFacets = useVModel(properties, "modelValue", emit);

const isOpen = computed(() => !!selectedFacets.value);
</script>
